import React from "react";

export default function SupportEmailFallback(): JSX.Element {
  return <>help@eatclub.com</>;
}
